import { Tags } from 'src/components';

const TagCell = ({ row }) => {
  const tags = row?.tags ? row.tags : row?.provider?.tags;
  if (!tags?.length) return null;

  const serializedTags = tags?.map((tag) => ({
    bgColor: tag.bg_color,
    fullText: tag.description,
    ...tag,
  }));

  return (
    <div className="flex items-center">
      <Tags tags={serializedTags || []} tagType="tag" size="small" />
    </div>
  );
};

export default TagCell;
